module.exports = __webpack_public_path__ + "static/media/collaborative-whiteboard.c85af14a.svg";